export default __webpack_public_path__ + "static/media/close_icon.ed7d5f51.svg";